<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card v-if="first_load">
      <v-card-text>
        <v-row justify="center">
          <v-col sm="3">
            <h3>Class teacher-Calendar</h3>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="current_academic_year"
              :items="ay_std_data.academic_year_list"
              item-text="Academic Year"
              label="Academic Year"
              outlined
            />
          </v-col>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="std"
              :items="ay_std_data.standard_list"
              item-text="Standard"
              label="Standard"
              outlined
            />
          </v-col>
          <v-col sm="2" v-if="division_list != null">
            <v-icon color="error">*</v-icon>
            <v-combobox
              dense
              required
              v-model="division"
              :items="division_list"
              item-text="divname"
              label="Division"
              outlined
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-radio-group v-model="event_type" row>
              <v-radio v-for="event in event_type_list" :key="event" :label="event" :value="event"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <v-datetime-picker dateFormat="dd-MM-yyyy" label="Select Datetime" v-model="datetime"></v-datetime-picker>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-text-field label="Title" v-model="title" placeholder="Colleges reopens"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            label="Description"
            v-model="description"
            value
            placeholder="Colleges reopens on...."
            hint="Enter description of notice or home work"
          ></v-textarea>
        </v-col>

        <v-btn @click="putCalendar" :loading="send_btn_load">Send</v-btn>
      </v-card-text>
    </v-card>
    <br />
    <div>
      <div>
        <v-data-table
          :items="calendar_list"
          :headers="headers"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" align="center" justify="center">
              <v-toolbar-title>List of Calendar Events</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.edit`]="{item}">
            <div>
              <v-btn
                color="secondary"
                icon
                dark
                v-on="on"
                @click="editDialog(item)"
                title="Edit Calendar Event"
              >
                <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                <v-icon>mdi-file-document-edit</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.delete`]="{item}">
            <div>
              <v-btn
                color="warning"
                icon
                dark
                v-on="on"
                @click="deleteCalendarEvent(item)"
                title="Delete Calendar Event"
              >
                <!-- <v-icon left>mdi-email-send-outline</v-icon> -->
                <v-icon>mdi-delete-empty</v-icon>
              </v-btn>
            </div>
          </template>
            <template v-slot:[`item.read_by_parent`]="{ item }">
            <div>
               <v-icon medium class="mr-2" @click="getStatus(item.id)"> mdi-eye-outline</v-icon>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- api-1 ends -->
    <!-- api-3 -->
    <v-dialog v-model="edit_dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  hint="cannot edit"
                  readonly
                  disabled
                  v-model="editedItem.date"
                  label="Sent Date"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  hint="cannot edit"
                  readonly
                  disabled
                  v-model="editedItem.from"
                  label="From"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  hint="cannot edit"
                  disabled
                  readonly
                  v-model="editedItem.to"
                  label="To"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field dense hint="editable" v-model="editedItem.title" label="Title"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  label="Description"
                  v-model="editedItem.description"
                  dense
                  placeholder="Colleges reopens on...."
                  hint="editable"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

       <v-dialog v-model="status_dialog" max-width="1200px">
 <v-card>
      <v-card-text>
        <v-data-table :headers="status_headers" :items="comm_read_status" :search="search">
          <template v-slot:top>
            <v-toolbar flat color="white" align="center" justify="center">
              <v-toolbar-title>List of Receipients</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
                 <strong>Total Receipients- </strong>{{total_receipients}}
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card-text>
        <v-card-actions class="justify-center"><v-btn class="dialog-btn" @click="status_dialog = false">Close</v-btn></v-card-actions>
    </v-card>
 </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    datetime: null,
    first_load: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    ay_std_data: null,
    fetch_btn_load: false,
    std: null,
    current_academic_year: null,
    attachments: [],
    title: null,
    description: null,
    division_list: ["All"],
    division: null,
    event_type_list: null,
    event_type: null,
    fetch_btn_load: false,
    send_btn_load: false,
    notice_list_load: false,
    calendar_list: "",
    edit_dialog: false,
    delete_attach_load: false,
    editedItem: {
      date: null,
      description: null,
      from: null,
      id: null,
      to: null,
      title: null
    },
    headers: [
      { text: "Date", value: "date", sortable: true },
      { text: "From", value: "from", sortable: true },
      { text: "To", value: "to", sortable: true },
      { text: "Title", value: "title", sortable: true },
      { text: "Description", value: "description", sortable: true },
      { text: "View Status", value: "read_by_parent", sortable: true },
      { text: "Edit", value: "edit", sortable: false },
      { text: "Delete", value: "delete", sortable: false }
    ],
     status_headers: [
      { text: "Sr No", value: "srno", sortable: true },
      { text: "Read By", value: "learner", sortable: true },
       { text: "Read Date", value: "read_date", sortable: true },
    ],
    comm_read_status:[],status_dialog:false,total_receipients:"",
  }),
  watch: {
    std() {
      this.getDivOff();
    },
    current_academic_year() {
      this.getDivOff();
    },
    division() {
      this.get_calendar();
    },
    edit_dialog(val) {
      val || this.close();
    }
  },
  methods: {
     getStatus(id){
       const formData = {
        comm_id:id,
      };
       axios
        .post("/Communication/getcommunicationStatus", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
           this.comm_read_status=res.data.read_list
           this.status_dialog=true
            this.total_receipients=res.data.total_receipients
          }  if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
           this.status_dialog=false
          } 
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
        });
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${a.getMonth() +
            1}-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    get_calendar() {
      this.notice_list_load = true;
      const formData = {
        ay: this.current_academic_year,
        division: this.division,
        std: this.std
      };
      axios
        .post("/communicationType/get_calendar_coord", formData)
        .then(res => {
          if (res.data.msg == "200") {
            this.calendar_list = res.data.calendar_list;
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.notice_list_load = false;
        });
    },
    putCalendar() {
      this.send_btn_load = true;
      let formData = new FormData();
      for (var i = 0; i < this.attachments.length; i++) {
        let file = this.attachments[i];

        formData.append("files", file);
      }
      formData.append("ay", this.current_academic_year);
      formData.append("std", this.std);
      if(this.division=="All")	
	        formData.append("div", this.division);	
	      else
        formData.append("div", this.division.id);
     // formData.append("div", this.division.id);
      formData.append("title", this.title);
      formData.append("description", this.description);
      formData.append("type", "Calendar");
      formData.append("event", this.event_type);
      formData.append("who", "CT");
      formData.append("eventdate", this.formatDate(this.datetime, true));
      axios
        .post("/communicationType/put_calendar_coord", formData, {})
        .then(res => {
          if (res.data.msg == "200") {
            if (res.data.status == "SUCCESS") {
              // alert("Success");
              this.showSnackbar(
                "#4caf50",
                "Calendar event added successfully..."
              ); // show snackbar on success
            } else {
              this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
              //alert(res.data.status_reason);
            }
            this.get_calendar();
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.send_btn_load = false;
        });
    },
    getDivOff() {
      //api-2
      //erase for api-3
      this.title = null;
      this.description = null;
      // this.records = [];
      // this.header_list = [];
      // this.xls_header = [];
      //ends
      this.division_list = ["All"];
      this.division = "All";
      // this.report_type = null;
      //this.send_msg_flag = false;
      if (this.std == "All") return;
      if (this.std != null && this.current_academic_year != null) {
        const formData = {
          std: this.std,
          ay: this.current_academic_year,
          who: "CT"
        };
        axios
          .post("/commonAPI/get_div_coord", formData)
          .then(res => {
            if (res.data.msg == "200") {
              if (this.division_list.length == 0) {
                alert("No div offered");
                this.division_list = null;
              } else {
                this.division_list = res.data.division_list;
                this.division_list.unshift("All");
                this.division = this.division_list[0];
              }
            } else {
              //error
            }
          })
          .catch(error => {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            //close loader
          });
      }
    },
    get_ay_std() {
      //api-1
      const formData = {
        who: "CT"
      };
      axios
        .post("/commonAPI/get_ay_std_coord", formData)
        .then(res => {
          if (res.data.msg == "200") {
            this.ay_std_data = res.data.co_ay_std_data;
            this.ay_std_data.standard_list.unshift("All");
            this.current_academic_year =
              res.data.co_ay_std_data.current_academic_year;
            this.std = this.ay_std_data.standard_list[0];
            this.division = "All";
            this.event_type_list = res.data.co_ay_std_data.event_type_list;
            this.event_type = this.event_type_list[0];
            this.get_calendar();
          } else {
            //error
          }
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.first_load = true;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editDialog(item) {
      this.awspath = localStorage.getItem("awspath");
      this.editedItem = item;
      this.edit_dialog = true;
      this.editItemIndex = this.event_type.indexOf(item);
      //alert(this.editItemIndex)
    },
    close() {
      this.edit_dialog = false;
    },
    save() {
      let formData = new FormData();
      // for (var i = 0; i < this.attachments.length; i++) {
      //   let file = this.attachments[i];

      //   formData.append("files", file);
      // }
      formData.append("title", this.editedItem.title);
      formData.append("description", this.editedItem.description);
      formData.append("comm_id", this.editedItem.id);
      axios
        .post("/communicationType/saveEditCommunication", formData)
        .then(res => {
          if (res.data.status == "SUCCESS") {
            this.showSnackbar(
              "#4caf50",
              "Calendar event updated successfully..."
            ); // show snackbar on success
            //Object.assign(this.album_list[this.editItemIndex], this.editedItem)
            this.get_ay_std();
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.close();
        });
    },
    deleteCalendarEvent(item) {
      this.delete_attach_load = true;
      //alert(item.id)
      if (!confirm("Are you sure you want to delete this calendar event?"))
        return;
      const formData = {
        comm_id: item.id
      };
      axios
        .post("/communicationType/deleteCommunication", formData)
        .then(res => {
          if (res.data.status == "YES") {
            //this.showSnackbar("#4caf50", res.data.status_reason); // show snackbar on success
            this.showSnackbar("#4caf50", "Calendar Event removed..."); // show snackbar on success
            //alert(res.data.status_reason)
            const index = this.event_type.indexOf(item);
            this.get_ay_std();
            //this.event_type.splice(index, 1);
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
            //alert(res.data.status_reason)
          }
        })
        .catch(error => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          //close loader
          this.delete_attach_load = false;
        });
    }
  },
  mounted() {
    this.get_ay_std();
  }
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}
.allot-btn:hover .allot-icon {
  color: white;
}
.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}
.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}
@media print {
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }
  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
</style>
